import { ActionText } from 'bricks-ui/packages/bricks-ui';

export default ActionText;
